import { BsPersonBoundingBox } from 'react-icons/bs'
import { FiShare2 } from 'react-icons/fi'
import { FaFacebookF, FaDiscord, FaTwitter, FaInstagram, FaYoutube, FaTiktok, FaTumblr } from 'react-icons/fa'

import './asideleft.css'
import UserAppContext from '../../hook/UserAppContext'
import Social from '../buttons/Social'

const AsideLeft = () => {

      const {user, dataApp} = UserAppContext() 
      const {infordata, social} = user.user 

      return (
            <div className="main_aside__left">
                  <div className="box_wrapper">
                        <div className="header_box__content">
                              <div className="header_content_icon">
                                    <BsPersonBoundingBox />
                              </div>
                              <h3>About Me</h3>
                        </div>
                        <div className="box_content">
                              <div className="aside_about__description">
                                    <p>
                                          {infordata.data || infordata.about === '' ? dataApp.info.about : infordata.about}
                                    </p>
                              </div>
                        </div>
                  </div>
                  <div className="box_wrapper">
                        <div className="header_box__content">
                              <div className="header_content_icon">
                                    <FiShare2 />
                              </div>
                              <h3>Social</h3>
                        </div>
                        <div className="box_content">
                              <div className="aside_social__menu">
                                    <Social link={social.data || social.facebook === '' ? dataApp.social.facebook : social.facebook} icon={<FaFacebookF/>} text={`facebook`}/>
                                    <Social link={social.data || social.twitter === '' ? dataApp.social.twitter : social.twitter} icon={<FaTwitter/>} text={`Twitter`}/>
                                    <Social link={social.data || social.instagram === '' ? dataApp.social.instagram : social.instagram} icon={<FaInstagram/>} text={`Instagram`}/>
                                    <Social link={social.data || social.youtube === '' ? dataApp.social.youtube : social.youtube} icon={<FaYoutube/>} text={`Youtube`}/>
                                    <Social link={social.data || social.tumblr === '' ? dataApp.social.tumblr : social.tumblr} icon={<FaTumblr/>} text={`Tumblr`}/>
                                    <Social link={social.data || social.tiktok === '' ? dataApp.social.tiktok : social.tiktok} icon={<FaTiktok/>} text={`Tiktok`}/>
                                    <Social link={social.data || social.discord === '' ? dataApp.social.discord : social.discord} icon={<FaDiscord/>} text={`Discord`}/>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default AsideLeft